import { Component } from 'react';
import { captureException } from '../../utils/sentryUtils';
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
    this.componentDidCatch = (error, errorInfo) => {
      console.error(error);
      captureException(error, {
        fingerprint: [this.props.fingerprint],
        extra: {
          errorInfo,
          componentStack: errorInfo.componentStack,
          error
        }
      });
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  render() {
    const {
      hasError
    } = this.state;
    if (!hasError) {
      return this.props.children || null;
    }
    if (this.props.errorComponent) {
      return this.props.errorComponent;
    }
    return null;
  }
}